import axios from 'axios'
import { config } from '@/config/config'

const API_V1 = '/api/v1'

// ─── Request Types ───────────────────────────────────────────────

export interface GetUserByMobileNumberRequest {
  mobileNumber: string
  restaurantId: string
}

export interface SignInWithMobileNumberRequest {
  firstName: string
  lastName: string
  mobileNumber: string
  email: string
  restaurantId: string
  storeId: string
  timeZone: string
}

export interface VerifyMobileOTPRequest {
  mobileNumber: string
  otp: string
  restaurantId: string
  storeId: string
}

export interface SendMobileOTPRequest {
  mobileNumber: string
  restaurantId: string
  storeId: string
  timeZone: string
}

export interface VerifyOTPRequest {
  mobileNumber: string
  otp: string
  restaurantId: string
  storeId: string
  timeZone: string
}

export interface ResendOTPRequest {
  mobileNumber: string
  restaurantId: string
  storeId: string
}

export interface FetchUserRequest {
  restaurantId: string
}

export interface UpdateUserDetailsRequest {
  firstName: string
  lastName: string
  email: string
  userId: string
  storeId: string
  restaurantId: string
}

export interface VerifyUpdatedMobileOTPRequest {
  mobileNumber: string
  otp: string
  userId: string
  restaurantId: string
  storeId: string
}

// ─── API Functions ───────────────────────────────────────────────

export const getUserByMobileNumber = async (
  params: GetUserByMobileNumberRequest
) => {
  const { data } = await axios.post(
    `${config.api.baseUrl}/getUserByMobileNumber`,
    params,
    {
      headers: { 'Content-Type': 'application/json' },
    }
  )
  return data
}

export const signInWithMobileNumber = async (
  params: SignInWithMobileNumberRequest
) => {
  const { data } = await axios.post(
    `${config.api.baseUrl}${API_V1}/signInWithMobileNumber`,
    params,
    {
      headers: {
        'Content-Type': 'application/json',
        'Access-Control-Allow-Origin': '*',
      },
    }
  )
  return data
}

export const verifyMobileOTP = async (params: VerifyMobileOTPRequest) => {
  const { data } = await axios.post(
    `${config.api.baseUrl}${API_V1}/verifyMobileOTP`,
    params,
    {
      headers: {
        'Content-Type': 'application/json',
        'Access-Control-Allow-Origin': '*',
      },
    }
  )
  return data
}

export const sendMobileOTP = async (params: SendMobileOTPRequest) => {
  const { data } = await axios.post(
    `${config.api.baseUrl}${API_V1}/sendMobileOTP`,
    params,
    {
      headers: {
        'Content-Type': 'application/json',
        'Access-Control-Allow-Origin': '*',
      },
    }
  )
  return data
}

export const verifyOTP = async (
  params: VerifyOTPRequest,
  token: string
) => {
  const { data } = await axios.post(
    `${config.api.baseUrl}${API_V1}/verifyOTP`,
    params,
    {
      headers: {
        'Content-Type': 'application/json',
        'Access-Control-Allow-Origin': '*',
        Authorization: `Bearer ${token}`,
      },
    }
  )
  return data
}

export const resendOTP = async (params: ResendOTPRequest) => {
  const { data } = await axios.post(
    `${config.api.baseUrl}${API_V1}/resendOTP`,
    params,
    {
      headers: {
        'Content-Type': 'application/json',
        'Access-Control-Allow-Origin': '*',
      },
    }
  )
  return data
}

export const fetchUser = async (
  params: FetchUserRequest,
  token: string
) => {
  const { data } = await axios.post(
    `${config.api.baseUrl}${API_V1}/fetchUser`,
    params,
    {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    }
  )
  return data
}

export const updateUserDetails = async (
  params: UpdateUserDetailsRequest
) => {
  const { data } = await axios.post(
    `${config.api.baseUrl}${API_V1}/updateUserDetails`,
    params,
    {
      headers: {
        'Content-Type': 'application/json',
        'Access-Control-Allow-Origin': '*',
      },
    }
  )
  return data
}

export const getCustomToken = async (idToken: string) => {
  const { data } = await axios.post(
    `${config.api.baseUrl}${API_V1}/customToken`,
    { token: idToken },
    {
      headers: {
        'Content-Type': 'application/json',
      },
    }
  )
  return data
}

export const createSessionCookie = async (idToken: string) => {
  const { data } = await axios.post(
    `${config.api.baseUrl}${API_V1}/sessionCookie`,
    { idToken },
    {
      headers: {
        'Content-Type': 'application/json',
      },
      withCredentials: true,
    }
  )
  console.log("the token to login was exchanges for the session cookie",data)
  return data
}

export const verifyUpdatedMobileOTP = async (
  params: VerifyUpdatedMobileOTPRequest
) => {
  const { data } = await axios.post(
    `${config.api.baseUrl}${API_V1}/verifyUpdatedMoblieOTP`,
    params,
    {
      headers: {
        'Content-Type': 'application/json',
        'Access-Control-Allow-Origin': '*',
      },
    }
  )
  return data
}
